module.exports = __webpack_public_path__ + "media/front/ico-email-0e52dd1e.svg";